module.exports = __webpack_public_path__ + "27e1762c676f630cf01d587b8c4422f6.jpg";